import { CarSearchbar } from '@features/cars/components/CarSearchbar'
import { hasPermission } from '@features/rbac/permissions'
import { createFileRoute } from '@tanstack/react-router'
import { redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/cars/search')({
    beforeLoad: () => {
        if (!hasPermission('cars.read')) {
            throw redirect({ to: '/unauthorised' })
        }
    },
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Search',
        }
    }
})

function RouteComponent() {
    return (
        <div className={'flex flex-col justify-center items-center h-full w-full gap-10'}>
            <CarSearchbar searchbarProps={{ size: 'lg', radius: 'lg' }}/>
        </div>
    )
}
